import React from "react";
// import loading from "../assets/loading.svg";

const Loading = () => (
  <div className="spinner">

    <h3 style={{color:"white", textAlign: "center"}}>Preparing your preferences...</h3>
  </div>
);

export default Loading;